export var useCache = "object" === 'undefined'
    ? require('./provider-server').useCache
    : require('./provider-browser').useCache;
var Provider = "object" === 'undefined'
    ? require('./provider-server').default
    : require('./provider-browser').default;
export default Provider;
//# sourceMappingURL=index.js.map